import React from 'react'
import { useTranslation } from 'react-i18next'
import useNavigateTo from 'hooks/useNavigateTo'
import { AppFC } from 'types'

import { getRoleFromPath } from 'utils/helper'
import { ROLES } from 'config'
import ActionCard from 'components/Common/ActionCard'
import { AppDashboardUpcomingEventsItems } from '../AppDashboardUpcomingEventsItems/AppDashboardUpcomingEventsItems'
import { IUpcomingEventsProps } from 'components/AppDashboard/interfaces'
import { AppointmentsSkeletonLoader } from 'components/AppAdvisorDashboard/AppAdvisorPlays/AppointmentsSkeletonLoader.component'

const AppDashboardUpcomingEvents: AppFC<IUpcomingEventsProps> = ({
  events = [],
  className = '',
  noEventsMessage = '',
  loading = false,
  showInternalMeetingsOnly = false,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigateTo('calendar')
  const userRole = getRoleFromPath()

  const noEventsScheduled = !loading && events.length === 0

  return (
    <div id="admin-upcoming-events-section" className={`space-y-5 ${className}`}>
      {loading ? (
        <AppointmentsSkeletonLoader />
      ) : (
        <div>
          {userRole?.includes(ROLES.BUSINESS_OWNER) ? (
            <div>
              {noEventsScheduled && (
                <p className="italic text-black-light text-lg sm:text-xl -mt-2">
                  {userRole === ROLES.V2
                    ? t('calendar.noAppointments')
                    : t('commandCenter.noAppointmentsToday')}
                </p>
              )}
              <div className="space-y-4">
                {noEventsScheduled ? (
                  <ActionCard onClick={() => navigate()}>
                    <div>
                      <p className="leading-6 font-semibold text-lg">{noEventsMessage}</p>
                    </div>
                  </ActionCard>
                ) : (
                  <AppDashboardUpcomingEventsItems
                    events={events}
                    showInternalMeetingsOnly={showInternalMeetingsOnly}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="h-[350px] bg-app-white-100 flex items-center justify-center font-medium text-sm">
              {t('commandCenter.cannotViewInformation')}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default AppDashboardUpcomingEvents
